import React, { ReactElement, ReactNode } from "react";
import { OverlayTrigger, OverlayTriggerProps, Tooltip as BootstrapTooltip } from "react-bootstrap";
import "./Tooltip.scss";

interface IProps {
    hide?: boolean;
    title: ReactNode;
    children: ReactElement;
    onMouseEnter?: (e) => void;
    onMouseLeave?: (e) => void;
}

export default function Tooltip({
    title,
    children,
    onMouseEnter,
    onMouseLeave,
    ...props
}: IProps & Omit<OverlayTriggerProps, "overlay" | "children">) {
    if (!title) {
        return children;
    }

    if (props.hide) {
        return children;
    }

    return (
        <OverlayTrigger
            placement={props.placement || "top"}
            {...props}
            overlay={
                <BootstrapTooltip onMouseLeave={onMouseLeave} onMouseEnter={onMouseEnter}>
                    {title}
                </BootstrapTooltip>
            }
        >
            {children}
        </OverlayTrigger>
    );
}
